import {
  mobile,
  backend,
  creator,
  web,
  javascript,
  typescript,
  html,
  css,
  reactjs,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  figma,
  meta,
  starbucks,
  tesla,
  shopify,
  carrent,
  jobit,
  tripguide,
} from "../assets";
import { GiTargetArrows } from "react-icons/gi";
import { FaSketch, FaTransgenderAlt } from "react-icons/fa";
import { AiOutlineSafety, AiOutlineContacts } from "react-icons/ai";

import img1 from "../assets/1566639.jpg";

export const rooms = [
  {
    id: "1",
    img: "https://r-xx.bstatic.com/xdata/images/xphoto/300x240/45450084.jpeg?k=f8c2954e867a1dd4b479909c49528531dcfb676d8fbc0d60f51d7b51bb32d1d9&o=",
    desc: "Our shared dorm rooms are a great option for budget-conscious travelers looking to meet new people. These rooms feature comfortable bunk beds and a shared bathroom. Lockers are provided for each guest to store their valuables. Each bed comes with a personal reading light and power outlet.",
    roomAvailabilities: "available",
    price: "5500/month",
    amenties: "Free wifi services",
  },
  {
    id: "2",

    img: "https://cf.bstatic.com/xdata/images/hotel/max300/354965222.webp?k=c9ee1896b1258f94768d9724d4d5b42d8cea9201ceb78f4ad3a62da3a33819bd&o=",
    desc: "Our shared dorm rooms are a great option for budget-conscious travelers looking to meet new people. These rooms feature comfortable bunk beds and a shared bathroom. Lockers are provided for each guest to store their valuables. Each bed comes with a personal reading light and power outlet.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
  {
    id: "3",

    img: "https://q-xx.bstatic.com/xdata/images/xphoto/300x240/57584488.jpeg?k=d8d4706fc72ee789d870eb6b05c0e546fd4ad85d72a3af3e30fb80ca72f0ba57&o=",
    desc: "Our family rooms are perfect for families or small groups traveling together. These spacious rooms feature comfortable beds for up to four guests, as well as a private bathroom and free Wi-Fi. The room is equipped with air conditioning, a flat-screen TV, and a small refrigerator.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
  {
    id: "4",

    img: "https://r-xx.bstatic.com/xdata/images/xphoto/300x240/45450084.jpeg?k=f8c2954e867a1dd4b479909c49528531dcfb676d8fbc0d60f51d7b51bb32d1d9&o=",
    desc: "Our deluxe suite is perfect for those seeking a bit more luxury. This spacious room features a comfortable king-size bed, a separate living area with a sofa, and a private balcony with stunning views. The room is equipped with air conditioning, free Wi-Fi, and a flat-screen TV. The private bathroom features a luxurious bathtub and separate shower.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
  {
    id: "5",

    img: "https://r-xx.bstatic.com/xdata/images/xphoto/300x240/45450084.jpeg?k=f8c2954e867a1dd4b479909c49528531dcfb676d8fbc0d60f51d7b51bb32d1d9&o=",
    desc: "Our shared dorm rooms are a great option for budget-conscious travelers looking to meet new people. These rooms feature comfortable bunk beds and a shared bathroom. Lockers are provided for each guest to store their valuables. Each bed comes with a personal reading light and power outlet.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
  {
    id: "6",

    img: "https://r-xx.bstatic.com/xdata/images/xphoto/300x240/45450084.jpeg?k=f8c2954e867a1dd4b479909c49528531dcfb676d8fbc0d60f51d7b51bb32d1d9&o=",
    desc: "Our shared dorm rooms are a great option for budget-conscious travelers looking to meet new people. These rooms feature comfortable bunk beds and a shared bathroom. Lockers are provided for each guest to store their valuables. Each bed comes with a personal reading light and power outlet.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
];
export const hostels = [
  {
    id: "3",

    img: "https://q-xx.bstatic.com/xdata/images/xphoto/300x240/57584488.jpeg?k=d8d4706fc72ee789d870eb6b05c0e546fd4ad85d72a3af3e30fb80ca72f0ba57&o=",
    desc: "Our family rooms are perfect for families or small groups traveling together. These spacious rooms feature comfortable beds for up to four guests, as well as a private bathroom and free Wi-Fi. The room is equipped with air conditioning, a flat-screen TV, and a small refrigerator.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
  {
    id: "4",

    img: "https://r-xx.bstatic.com/xdata/images/xphoto/300x240/45450084.jpeg?k=f8c2954e867a1dd4b479909c49528531dcfb676d8fbc0d60f51d7b51bb32d1d9&o=",
    desc: "Our deluxe suite is perfect for those seeking a bit more luxury. This spacious room features a comfortable king-size bed, a separate living area with a sofa, and a private balcony with stunning views. The room is equipped with air conditioning, free Wi-Fi, and a flat-screen TV. The private bathroom features a luxurious bathtub and separate shower.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
  {
    id: "5",

    img: "https://r-xx.bstatic.com/xdata/images/xphoto/300x240/45450084.jpeg?k=f8c2954e867a1dd4b479909c49528531dcfb676d8fbc0d60f51d7b51bb32d1d9&o=",
    desc: "Our shared dorm rooms are a great option for budget-conscious travelers looking to meet new people. These rooms feature comfortable bunk beds and a shared bathroom. Lockers are provided for each guest to store their valuables. Each bed comes with a personal reading light and power outlet.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
  {
    id: "6",

    img: "https://r-xx.bstatic.com/xdata/images/xphoto/300x240/45450084.jpeg?k=f8c2954e867a1dd4b479909c49528531dcfb676d8fbc0d60f51d7b51bb32d1d9&o=",
    desc: "Our shared dorm rooms are a great option for budget-conscious travelers looking to meet new people. These rooms feature comfortable bunk beds and a shared bathroom. Lockers are provided for each guest to store their valuables. Each bed comes with a personal reading light and power outlet.",
    roomAvailabilities: "available",
    price: "3500/month",
    amenties: "Free wifi services",
  },
];

export const rules = [
  {
    title: "Smoking is not allowed",
    description:
      "No smoking or drug use is allowed in the hostel rooms or common areas.You will be punished for this activity",
  },
  {
    title: "Be Silent",
    description:
      "Quiet hours must be observed, usually from 10 PM to 7 AM. Dont make noise between this hours else u will be violating rules..",
  },
  {
    title: "Visitors",
    description:
      "Visitors are generally not allowed in the hostel rooms. But in case if there is any emergency then before letting them ,notify the warden and admanistrator",
  },
  {
    title: "Where to eat food",
    description:
      "Food must be stored and consumed only in designated areas, usually the kitchen or dining room.",
  },
  {
    title: "Personal Belongings",
    description:
      "Personal belongings must be kept secure at all times, and the hostel is not responsible for any lost or stolen items.",
  },
];

export const postData = [
  {
    img: img1,
    name: "Shubham",
    desc: "Hi there whats going on ???",
    likes: 5000,
    liked: true,
  },
  {
    img: img1,
    name: "Shubham",
    desc: "Hi there whats going on ???",
    likes: 5000,
    liked: true,
  },
  {
    img: img1,
    name: "Shubham",
    desc: "Hi there whats going on ???",
    likes: 5000,
    liked: true,
  },
  {
    img: img1,
    name: "Shubham",
    desc: "Hi there whats going on ???",
    likes: 5000,
    liked: true,
  },
  {
    img: img1,
    name: "Shubham",
    desc: "Hi there whats going on ???",
    likes: 5000,
    liked: true,
  },
  {
    img: img1,
    name: "Shubham",
    desc: "Hi there whats going on ???",
    likes: 5000,
    liked: true,
  },
  {
    img: img1,
    name: "Shubham",
    desc: "Hi there whats going on ???",
    likes: 5000,
    liked: true,
  },
];
export const navLinks = [
  {
    id: "home",
    title: "Home",
  },
  {
    id: "about",
    title: "About",
  },
  {
    id: "hostels",
    title: "Hostels",
  },
  {
    id: "rooms",
    title: "Room",
  },

  {
    id: "blog",
    title: "Blog",
  },

  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "Safety and security",
    icon: web,
  },
  {
    title: "Cleanliness",
    icon: mobile,
  },
  {
    title: "Maintenance",
    icon: backend,
  },
  {
    title: "Student housing",
    icon: creator,
  },
];

const technologies = [
  {
    name: "HTML 5",
    icon: html,
  },
  {
    name: "CSS 3",
    icon: css,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "TypeScript",
    icon: typescript,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Node JS",
    icon: nodejs,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },
  // {
  //   name: "Three JS",
  //   icon: threejs,
  // },
  {
    name: "git",
    icon: git,
  },
  {
    name: "figma",
    icon: figma,
  },
  // {
  //   name: "docker",
  //   icon: docker,
  // },
];

const experiences = [
  {
    title: "Safety and security",
    // company_name: "Starbucks",
    icon: starbucks,
    iconBg: "#383E56",
    date: "Rule1",
    points: [
      "The safety and security of students should be the top priority of hostel management. Proper security measures such as surveillance cameras, fire alarms, and emergency response plans should be in place..",
    ],
  },
  {
    title: "Noise restrictions",
    // company_name: "Tesla",
    icon: tesla,
    iconBg: "#E6DEDD",
    date: "Rule2",
    points: [
      ".Noise levels should be controlled during specific hours to ensure a peaceful environment for everyone. Loud music, shouting, or any other disturbance should be strictly prohibited.",
    ],
  },
  {
    title: "Guest policy",
    // company_name: "Shopify",
    icon: shopify,
    iconBg: "#383E56",
    date: "Rule3",
    points: [
      "Hostel management should set guidelines for the number of guests that can be allowed, their duration of stay, and the areas they can access.",
    ],
  },
  {
    title: "Cleanliness",
    // company_name: "Meta",
    icon: meta,
    iconBg: "#E6DEDD",
    date: "Rule4",
    points: [
      "It is important to maintain a clean and hygienic environment in the hostel. Regular cleaning schedules should be followed, and students should be encouraged to maintain cleanliness and hygiene in their own rooms.",
    ],
  },
  {
    title: "Respect for others",
    // company_name: "Meta",
    icon: meta,
    iconBg: "#E6DEDD",
    date: "Rule5",
    points: [
      "Hostel management should encourage a culture of mutual respect among students. Any form of bullying, harassment, discrimination, or inappropriate behavior should not be tolerated.",
    ],
  },
  {
    title: "Discipline",
    // company_name: "Meta",
    icon: meta,
    iconBg: "#E6DEDD",
    date: "Rule6",
    points: [
      "Hostel management should establish clear guidelines for disciplinary actions in case of violation of hostel rules. The consequences of violating rules should be made clear to all students to prevent any form of misconduct.",
    ],
  },
];

const testimonials = [
  {
    testimonial:
      "I thought it was impossible to make a website as beautiful as our product, but Rick proved me wrong.",
    name: "Sara Lee",
    designation: "CFO",
    company: "Acme Co",
    image: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    testimonial:
      "I've never met a web developer who truly cares about their clients' success like Rick does.",
    name: "Chris Brown",
    designation: "COO",
    company: "DEF Corp",
    image: "https://randomuser.me/api/portraits/men/5.jpg",
  },
  {
    testimonial:
      "After Rick optimized our website, our traffic increased by 50%. We can't thank them enough!",
    name: "Lisa Wang",
    designation: "CTO",
    company: "456 Enterprises",
    image: "https://randomuser.me/api/portraits/women/6.jpg",
  },
];

const aboutUs = [
  {
    icon: <GiTargetArrows />,
    heading: "Our Mission",
    desc: "The mission of hostel management is to create a safe, comfortable, and supportive living environment for residents. This includes providing basic necessities such as clean water, food, shelter, and security. Hostel management also strives to foster a sense of community among residents, encouraging them to form social connections and engage in activities together.",
  },
  {
    icon: <FaSketch />,
    heading: "Our Values",
    desc: "HMS values responsibility in maintaining the hostel facilities and ensuring the safety and security of residents. This includes regular maintenance, repairs, and upgrades to the facilities, as well as implementing safety protocols and emergency procedures.",
  },
  {
    icon: <FaTransgenderAlt />,
    heading: "Facilities",
    desc: "Different amenities available to guests, such as wifi, television, air conditioning, and heating. Mention any additional amenities, such as complimentary breakfast, access to a gym, or laundry facilities.",
  },
  {
    icon: <AiOutlineSafety />,
    heading: "Safety and security",
    desc: "secure entrances, CCTV cameras, or on-site security personnel. Mention any emergency procedures, such as fire evacuation plans or first aid kits.",
  },
  {
    icon: <AiOutlineSafety />,
    heading: "Safety and security",
    desc: "secure entrances, CCTV cameras, or on-site security personnel. Mention any emergency procedures, such as fire evacuation plans or first aid kits.",
  },
  {
    icon: <AiOutlineContacts />,
    heading: "Contact Info",
    desc: "rechms@gmail.com",
    desc1: "9989767812",
  },
];

const projects = [
  {
    name: "Car Rent",
    description:
      "Web-based platform that allows users to search, book, and manage car rentals from various providers, providing a convenient and efficient solution for transportation needs.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: carrent,
    source_code_link: "https://github.com/",
  },
  {
    name: "Job IT",
    description:
      "Web application that enables users to search for job openings, view estimated salary ranges for positions, and locate available jobs based on their current location.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "restapi",
        color: "green-text-gradient",
      },
      {
        name: "scss",
        color: "pink-text-gradient",
      },
    ],
    image: jobit,
    source_code_link: "https://github.com/",
  },
  {
    name: "Trip Guide",
    description:
      "A comprehensive travel booking platform that allows users to book flights, hotels, and rental cars, and offers curated recommendations for popular destinations.",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "supabase",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: tripguide,
    source_code_link: "https://github.com/",
  },
];

export { services, technologies, experiences, testimonials, projects, aboutUs };
